module.exports = __webpack_public_path__ + "static/media/scanner-keyboard.ec9c7050.svg";